
import { ComponentWidget } from "./ComponentWidget";
import { CoatingsComponentController } from "../CoatingsComponentController";
import { Coating } from "@rhinov/savane-js";
import { _ASSET_TYPE, getAsset, getToken } from "@rhinov/asset-manager-service";



export class CoatingsComponentWidget extends ComponentWidget {

    coatingsController: CoatingsComponentController;
    coatingsEvent: Array<{id: string, event: string, handler: (event: Event) => void, param: string | null, set: {id: string, value: any} | null}>;
    coating: Coating;


    protected lock(event: MouseEvent) {
        this.coatingsController.getUpdateProperty('locked', this.coating, (event.currentTarget as HTMLInputElement).checked);
    }

    protected remove(event: MouseEvent) {
        super.removeCommonListener();
        this.destroyCoatingsListener();
        let coating = document.getElementById(`CoatingContainer-${this.index}`);
        if (coating) {
            coating.innerHTML = "";
        }
        this.coatingsController.removeComponent();
        event.stopPropagation();
    }

    

    protected setColorIndex(event: Event) {
        this.coatingsController.changeConfigId(this.coating, Number((event.currentTarget as HTMLInputElement & { param?: string }).param));
        let index = document.getElementById(`colorIndex-${this.index}`);
        if (index) {
            index.innerHTML = this.coatingsController.getValueProperty('colorIndex', this.coating).toString();
        }
        var arg = (event.currentTarget as HTMLInputElement & { param?: string }).param === "1" ? 1 : 2;
        (event.currentTarget as HTMLButtonElement).disabled = (this.coating.colors.length <= 1 || this.coatingsController.getValueProperty('colorIndex', this.coating) != arg) ? true : false;
    }

    protected setPropertyTile(event: Event) {
        if ((event.currentTarget as HTMLInputElement).value === "") {
            (event.currentTarget as HTMLInputElement).value = String(0);
        }
        this.coatingsController.getUpdateTileFGProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.coating, Number((event.currentTarget as HTMLInputElement).value));
    }

    protected setPropertyJoint(event: Event) {
        if ((event.currentTarget as HTMLInputElement).value === "") {
            (event.currentTarget as HTMLInputElement).value = "0";
        }
        this.coatingsController.getUpdateJointFGProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.coating, Number((event.currentTarget as HTMLInputElement).value));
    }

    protected setPatternComponentFG(event: Event) {
        this.coatingsController.getUpdateFGProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.coating, (event.currentTarget as HTMLInputElement).value);
        this.destroyCoatingsListener();
        var container = document.getElementById(`coating-${this.index}`);
        if (container) {
            container.innerHTML = this.RotationHtml() + this.ManageFloorGenerator();
        }
        this.setEventList();
        setTimeout(this.setCoatingsListener.bind(this), 200);
    }
    
    protected rotate(event: Event) {
        if ((event.currentTarget as HTMLInputElement).value === "") {
            (event.currentTarget as HTMLInputElement).value = String(0);
        }
        this.coatingsController.getUpdateProperty('rotation', this.coating, (event.currentTarget as HTMLInputElement).value);
        let box = document.getElementById(`rotationBox-${this.index}`) as HTMLInputElement;
        if (box) {
            box.value = this.coating.rotation.toString();
        }
        let range = document.getElementById(`rotationRange-${this.index}`) as HTMLInputElement;
        if (range) {
            range.value = this.coating.rotation.toString();
        }
    }

    protected setProperty(event: Event) {
        var key = (event.currentTarget as HTMLElement & {param?: string}).param;
        if ((event.currentTarget as HTMLInputElement).value === "") {
            (event.currentTarget as HTMLInputElement).value = "0";
        }
        this.coatingsController.getUpdateProperty(key!, this.component as Coating, (event.currentTarget as HTMLInputElement).value);
        var container = (event.currentTarget as HTMLElement).parentElement;
        if (container){
            container = container.parentElement;
        }
        if (container) {
            container = container.parentElement;
            var htmltext = container?.querySelector('h5.labelRange');
            if (htmltext) {
                htmltext.textContent = (this.rangeText as any)[key!] + this.coatingsController.dispvalue(this.coatingsController.getValueProperty(key!, this.component as Coating));
            }
        }
    }

    protected setPropertyComponentFG(event: Event) {
        if ((event.currentTarget as HTMLInputElement).value === "") {
            if ((event.currentTarget as HTMLInputElement).min) {
                (event.currentTarget as HTMLInputElement).value = (event.currentTarget as HTMLInputElement).min
            } else {
                (event.currentTarget as HTMLInputElement).value = "0";
            }

        }
        this.coatingsController.getUpdateFGProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.coating, (event.currentTarget as HTMLInputElement).value);
    }

    rangeText = {offsetX: "Offset X: ", offsetY: "Offset Y: ", repeatX: "Répétition X: x ", repeatY: "Répétition Y: x "};

    constructor (component: Coating, index: number) {
        super(component, index);
        this.coating = component;
        this.coatingsController = new CoatingsComponentController(component);
        this.coatingsEvent = [];
        this.setEventList();
    }

    setEventList() {
        this.coatingsEvent = [
            {id:"lockButton-", event: "change", handler: (e: Event) => this.lock(e as MouseEvent), param: null, set: {id: 'checked', value: this.coating.locked}},
            {id:"rotationBox-", event: "input", handler: (e: Event) => this.rotate(e), param: null, set: {id: 'value', value: this.coating.rotation}},
            {id:"rotationRange-", event: "input", handler: (e: Event) => this.rotate(e), param: null, set: {id: 'value', value: this.coating.rotation}},
            {id:"offsetxComponent-", event: "input", handler: (e: Event) => this.setProperty(e), param: "offsetX", set: {id: 'value', value: Math.round(this.coating.offset[0] * 100)}},
            {id:"offsetyComponent-", event: "input", handler: (e: Event) => this.setProperty(e), param: "offsetY", set: {id: 'value', value: Math.round(this.coating.offset[1] * 100)}},
            {id:"repeatxComponent-", event: "input", handler: (e: Event) => this.setProperty(e), param: "repeatX", set: {id: 'value', value: Math.round(this.coating.repeat[0] * 100)}},
            {id:"repeatyComponent-", event: "input", handler: (e: Event) => this.setProperty(e), param: "repeatY", set: {id: 'value', value: Math.round(this.coating.repeat[1] * 100)}},
            {id:"previousColorId-", event: "click", handler: (e: Event) => this.setColorIndex(e), param: "1", set: null},
            {id:"nextColorId-", event: "click", handler: (e: Event) => this.setColorIndex(e), param: "-1", set: null},
            {id:"removeCoating-", event: "click", handler: (e: Event) => this.remove(e as MouseEvent), param: null, set: null},
        ];
        if (this.coating.floorGeneratorSettings) {
            this.coatingsEvent = [...this.coatingsEvent, ...[
                {id:"widthTileFGComponent-", event: "input", handler: (e: Event) => this.setPropertyTile(e), param: "width", set: {id: 'value', value: this.coating.floorGeneratorSettings.tile.dimensions.width / 10}},
                {id:"lengthTileFGComponent-", event: "input", handler: (e: Event) => this.setPropertyTile(e), param: "length", set: {id: 'value', value: this.coating.floorGeneratorSettings.tile.dimensions.length / 10}},
                {id:"heightTileFGComponent-", event: "input", handler: (e: Event) => this.setPropertyTile(e), param: "height", set: {id: 'value', value: this.coating.floorGeneratorSettings.tile.dimensions.height / 10}},
                {id:"widthJointFGComponent-", event: "input", handler: (e: Event) => this.setPropertyJoint(e), param: "width", set: {id: 'value', value: this.coating.floorGeneratorSettings.joint.dimensions.width / 10}},
                {id:"lengthJointFGComponent-", event: "input", handler: (e: Event) => this.setPropertyJoint(e), param: "length", set: {id: 'value', value: this.coating.floorGeneratorSettings.joint.dimensions.length / 10}},
                {id:"heightJointFGComponent-", event: "input", handler: (e: Event) => this.setPropertyJoint(e), param: "height", set: {id: 'value', value: this.coating.floorGeneratorSettings.joint.dimensions.height / 10}},
                {id:"maxWidthJointFGComponent-", event: "input", handler: (e: Event) => this.setPropertyJoint(e), param: "maxWidth", set: {id: 'value', value: this.coating.floorGeneratorSettings.joint.dimensions.maxWidth / 10}},
                {id:"maxLengthJointFGComponent-", event: "input", handler: (e: Event) => this.setPropertyJoint(e), param: "maxLength", set: {id: 'value', value: this.coating.floorGeneratorSettings.joint.dimensions.maxLength / 10}},
                {id:"bevelValueFGComponent-", event: "input", handler: (e: Event) => this.setPropertyComponentFG(e), param: "bevelValue", set: {id: 'value', value: this.coating.floorGeneratorSettings.bevelValue / 10}},
                {id:"offsetXFGComponent-", event: "input", handler: (e: Event) => this.setPropertyComponentFG(e), param: "offsetX", set: {id: 'value', value: this.coating.floorGeneratorSettings.offsetX / 10}},
                {id:"offsetYFGComponent-", event: "input", handler: (e: Event) => this.setPropertyComponentFG(e), param: "offsetY", set: {id: 'value', value: this.coating.floorGeneratorSettings.offsetY / 10}},
                {id:"patternFGComponent-", event: "change", handler: (e: Event) => this.setPatternComponentFG(e), param: "pattern", set: {id: 'value', value: this.coating.floorGeneratorSettings.pattern}},
                {id:"defaultRowOffsetFGComponent-", event: "input", handler: (e: Event) => this.setPropertyComponentFG(e), param: "defaultRowOffset", set: {id: 'value', value: this.coating.floorGeneratorSettings.defaultRowOffset}},
                {id:"chevronAngleFGComponent-", event: "input", handler: (e: Event) => this.setPropertyComponentFG(e), param: "chevronAngle", set: {id: 'value', value: this.coating.floorGeneratorSettings.chevronAngle}},
                {id:"weaveNumberFGComponent-", event: "input", handler: (e: Event) => this.setPropertyComponentFG(e), param: "weaveNumber", set: {id: 'value', value: this.coating.floorGeneratorSettings.weaveNumber}},
                
            ]];
        }
    }

    setCoatingsListener() {
        this.coatingsEvent.forEach(({id, event, handler, param, set}) => {
            let element = document.getElementById(id + this.index) as HTMLInputElement & { param?: string };
            if (!element) return;
            if (param) {
                element.param = param;
            }
            if (set){
                if (set.value) {
                    (element as any)[set.id] = set.value;
                } else {
                    (element as any)[set.id] = 0;
                }
            }
            element.addEventListener(event, handler);
        })
    }

    destroyCoatingsListener() {
        this.coatingsEvent.forEach(({id, event, handler}) => {
            let element = document.getElementById(id + this.index);
            if (!element) return;
            element.removeEventListener(event, handler);
        })

    }

    init(endCallback: CallableFunction) {
        getAsset(_ASSET_TYPE.COATINGS, this.coating.coatingId, getToken(),
            (res: any) => {
                (this.component as any).infos = res;
                endCallback();
        });
    }

    setListener() {
        super.setCommonListener();
        this.setCoatingsListener();
        return;
    }

    override destroy() {
        super.removeCommonListener();
        this.destroyCoatingsListener();
        return;
    }


    noFloorGeneratorHtml(): string {
        return `
            <div style="display:inline-block">
                <div style="padding-right:16px">
                    <div>
                        <h5 class="labelRange">Offset X: ${this.coatingsController.dispvalue(this.coatingsController.getValueProperty('offsetX', this.coating))}%</h5>
                    </div>
                    <div style="display:inline-flex">
                        <p>0%</p>
                        <div>
                            <input id="offsetxComponent-${this.index}" class="inputRange_offsetX" min="0" max="100" type="range"/>
                        </div>
                        <p>100%</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h5 class="labelRange">Offset Y: ${this.coatingsController.dispvalue(this.coatingsController.getValueProperty('offsetY', this.coating))}%</h5>
                    </div>
                    <div style="display:inline-flex">
                        <p>0%</p>
                        <div>
                            <input id="offsetyComponent-${this.index}" class="inputRange_offsetY"min="0" max="100" type="range"/>
                        </div>
                        <p>100%</p>
                    </div>
                </div>
            </div>
            <div style="display:inline-block">
                <div style="padding-right:16px">
                    <div>
                        <h5 class="labelRange">Répétition X: x ${this.coatingsController.dispvalue(this.coatingsController.getValueProperty('repeatX', this.coating) / 100)}
                        </h5>
                    </div>
                    <div style="display:inline-flex">
                        <p>x 0.01</p>
                        <div>
                            <input id="repeatxComponent-${this.index}" class="inputRange_repeatX" min="1" max="500" type="range" />
                        </div>
                        <p>x 5</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h5 class="labelRange">Répétition Y: x ${this.coatingsController.dispvalue(this.coatingsController.getValueProperty('repeatY', this.coating) / 100)}
                        </h5>
                    </div>
                    <div style="display:inline-flex">
                        <p>x 0.01</p>
                        <div>
                            <input id="repeatyComponent-${this.index}" class="inputRange_repeatY" min="1" max="500" type="range" />
                        </div>
                        <p>x 5</p>
                    </div>
                </div>
            </div>
        `;
    }

    RotationHtml(): string {
        return ` 
            <div style="display:inline-block">
                <div>
                    <div class="input-wrapper">
                        <h5>Rotation:</h5>
                        <input id="rotationBox-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                            type="number" style="width:40px;padding:4px;margin-left:4px">
                        <h5>°</h5>
                    </div>
                </div>
                <p>-180°</p>
                <div>
                    <input id="rotationRange-${this.index}" class="inputRange_rotation" min="-180" max="180" type="range" />
                </div>
                <p>+180°</p>
            </div>
        `;
    }

    ManageLockButton(): string {
        if (this.coating.locked !== undefined) {
            return `
                <div style="width:100px;" class="padding">
                    <div style="display:inline-block">
                        <label class="horizontal-toggle">
                            <div style="padding-right: 10px">Bloqué</div>
                            <input id="lockButton-${this.index}" type="checkbox">
                            <span class="toggle"></span>
                        </label>
                    </div>
                </div>
            `
        }
         return "";
    }

    ManageFloorGenerator(): string {
        var html = "";
        if (!this.coating.floorGeneratorSettings) {
            return this.noFloorGeneratorHtml();
        }
        html += `
            <div style="display:inline-block;padding-right:16px">
                <div class="input-wrapper">
                    <h5>Largeur:</h5>
                    <input id="widthTileFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                `;
        if (this.coating.floorGeneratorSettings.pattern !== 'basket' && this.coating.floorGeneratorSettings.pattern !== 'hexagon'){
            html += `
                <div class="input-wrapper">
                    <h5>Longueur:</h5>
                    <input id="lengthTileFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
            `;
        }
        html += `
                <div class="input-wrapper">
                    <h5>Hauteur:</h5>
                    <input id="heightTileFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
            </div>
            <div style="display:inline-block;padding-right:16px">
                <div class="input-wrapper">
                    <h5>Largeur joint:</h5>
                    <input id="widthJointFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" step="0.1" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                <div class="input-wrapper">
                    <h5>Longueur joint:</h5>
                    <input id="lengthJointFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" step="0.1" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                <div class="input-wrapper">
                    <h5>Profondeur joint:</h5>
                    <input id="heightJointFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" step="0.1" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
            </div>
            <div style="display:inline-block;padding-right:16px">
        `;
        if (this.coating.floorGeneratorSettings.pattern === 'standard') {
            html += `
                <div class="input-wrapper">
                    <h5>Largeur maximale:</h5>
                    <input id="maxWidthJointFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                <div class="input-wrapper">
                    <h5>Longueur maximale:</h5>
                    <input id="maxLengthJointFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
            `;
        }
        html += `
            <div class="input-wrapper">
                    <h5>Chanfrein:</h5>
                    <input id="bevelValueFGComponent-${this.index}" class="inputEnterValited form-control"
                        type="number" step="0.1" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                <div>
                    <h5>Pattern:</h5>
                    <div>
                        <select id="patternFGComponent-${this.index}" class="inputEnterValited form-control" style="padding:4px;margin-left:4px">
                            <option value="standard">Standard</option>
                            <option value="herringbone">Herringbone</option>
                            <option value="chevron">Chevron</option>
                            <option value="basket">Basket Weave</option>
                            <option value="hexagon">Hexagon</option>
                        </select>
                    </div>
                </div>
            </div>
            <div style="display:inline-block">
                <div style="padding-right:16px">
                    <div class="input-wrapper">
                        <h5>Décalage X:</h5>
                        <input id="offsetXFGComponent-${this.index}" class="inputEnterValited form-control"
                            type="number" style="width:40px;padding:4px;margin-left:4px">
                        <h5>cm</h5>
                    </div>
                </div>
                <div>
                    <div class="input-wrapper">
                        <h5>Décalage Y:</h5>
                        <input id="offsetYFGComponent-${this.index}" class="inputEnterValited form-control"
                            type="number" style="width:40px;padding:4px;margin-left:4px">
                        <h5>cm</h5>
                    </div>
                </div>
            </div>
            <div style="display:inline-block">
        `;

        if (this.coating.floorGeneratorSettings.pattern === 'standard') {
            html += `
                <div style="padding-right:16px">
                    <div class="input-wrapper">
                        <h5>Décalage de pose:</h5>
                        <input id="defaultRowOffsetFGComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                            type="number" min="0" max="1" step="0.01" style="width:40px;padding:4px;margin-left:4px">
                    </div>
                </div>
            `;
        }
        if (this.coating.floorGeneratorSettings.pattern === 'chevron') {
            html += `
                <div style="padding-right:16px">
                    <div class="input-wrapper">
                        <h5>Angle:</h5>
                        <input id="chevronAngleFGComponent-${this.index}" onClick="this.select();" min="0" max="89" class="inputEnterValited form-control"
                                type="number" style="width:40px;padding:4px;margin-left:4px">
                        <h5>°</h5>
                    </div>
                </div>
            `;
        }
        if (this.coating.floorGeneratorSettings.pattern === 'basket') {
            html += `
                <div style="padding-right:16px">
                    <div class="input-wrapper">
                        <h5>Nombre de lattes</h5>
                        <input id="weaveNumberFGComponent-${this.index}"class="inputEnterValited form-control"
                            type="number" min="1" step="1" style="width:40px;padding:4px;margin-left:4px">
                    </div>
                </div>
            `;
        }
        return html + this.endFloorgenerator();
    }

    endFloorgenerator(): string {
        return `
            </div>
        `;
    } 
    
    html(): string {
        return `
            ${this.headerCoatings()}
                <div class="config-editor">
                    <!-- config id -->
                    <button id="previousColorId-${this.index}" style="padding : 0!important" class="btn-flat btn borderless"
                        disabled="${(this.coating.colors.length <= 1 || this.coatingsController.getValueProperty('colorIndex', this.coating) != 2) ? "disabled" : ""}">
                        &lt;
                    </button>
                    <div id="colorIndex-${this.index}">
                        ${this.coatingsController.getValueProperty('colorIndex', this.coating)}
                    </div>
                    <button id="nextColorId-${this.index}" style="padding : 0!important" class="btn-flat btn borderless"
                        disabled="${(this.coating.colors.length <= 1 || this.coatingsController.getValueProperty('colorIndex', this.coating) != 1) ? "disabled" : ""}">
                        >
                    </button>
                </div>
                ${this.bodyCoatings()}
        `;
    }

    headerCoatings(): string {
        return `<div id="CoatingContainer-${this.index}">` + super.CommonHeader(true) + `<div class="component-action" style="flex-flow: row wrap;">
            Actions:
            `;
    }

    bodyCoatings(): string {
        return `
                <button id="removeCoating-${this.index}" class="btn-flat btn borderless">
                    <span class="material-icons icon-Delete"></span>
                </button>

                <div style="width:100%;"></div>

                ${this.ManageLockButton()}

                <!--Range input -->
                <div id="coating-${this.index}" style="min-width:200px;" class="padding">
                    ${this.RotationHtml()}
                    ${this.ManageFloorGenerator()}    
                </div>
            </div>
        </div>
    
        `;
    }
}